import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { CoverageRegionModel } from './models';

export function fetchRegionsService(client: ApiClient = apiClient) {
  return client.get<CoverageRegionModel[]>(`/regions`);
}
